<template>
  <v-container>
    <creditor-objection-view-component v-if="user && user.profile == 1"></creditor-objection-view-component>
    <lawyer-objection-view-component v-if="user && user.profile == 4"></lawyer-objection-view-component>


    <v-dialog v-model="dialogPopup" :width="600">

      <v-card>
        <v-img src="@/assets/images/calendario-popup.png" height="auto" width="600"></v-img>
        <v-card-actions>
          <v-btn color="primary" @click="dialogPopup = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

  </v-container>
</template>

<script>
import 'moment/locale/pt-br'
import CreditorObjectionViewComponent from '@/components/creditor/CreditorObjectionViewComponent.vue'
import LawyerObjectionViewComponent from '@/components/lawyer/LawyerObjectionViewComponent.vue'

export default {
  components: {
    'creditor-objection-view-component': CreditorObjectionViewComponent,
    'lawyer-objection-view-component': LawyerObjectionViewComponent,
  },
  data: () => ({
    user: null,
    dialogPopup: false,
  }),

  created() {
    this.dialogPopup = true;

    this.$ga.event({
      eventCategory: 'page',
      eventAction: 'action',
      eventLabel: 'click',
      eventValue: 'user-area'
    })

    this.user = this.$root.user;

    console.log('object view user', this.user)

  },

}
</script>

<style lang="scss"></style>
